import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import Assets from '../../helpers/Assets';
import t from '../../lib/I18n';
import GooglePayPayment from '../../records/order/GooglePayPayment';


const GooglePayPaymentDetails = ({ small, payment }) => (
    <span className={ classnames('payment-details', { 'payment-details--small': small }) }>
        <img className="payment-details__image payment-details__image--google-pay" src={ Assets.assetUrl("images/google-pay-only-logo-small.png") } alt="Google Pay logo" />
        <span className="payment-details__account-name payment-details__account-name--google-pay">{ t('payment.details.googlePay', { googlePayAccount: payment.pan }) }</span>
    </span>
);

GooglePayPaymentDetails.propTypes = {
    payment: PropTypes.instanceOf(GooglePayPayment).isRequired,
    small: PropTypes.bool
};

GooglePayPaymentDetails.defaultProps = {
    small: false
};

export default GooglePayPaymentDetails;
